import * as React from "react";
const CheveuxF3 = ({ fillColor = "#FFDFC4", strokeColor = "#000000" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 1234">
		<defs>
			<style>
				{`.cls-1 { fill: none; } .cls-2 { stroke-miterlimit: 10; }`}
			</style>
		</defs>
		<title>{"cheveux F 1"}</title>
		<g id="cadre">
			<rect className="cls-1" width={408} height={1220} />
		</g>
		<g id="cheveux">
			<path
				id="frame_1_F"
				data-name="frame 1 F"
				className="cls-2"
				fill={fillColor} // 👈 Apply dynamic fill color
				stroke={strokeColor} // 👈 Apply dynamic stroke color
				d="M1025.5,625.5s5,0,7,6,3,18,3,18-13.16-8.15-19-21c-8.84,16.15-65,37-95,31,33-32,3-122,30-153,10-16,38-36,61-12,11.11-12.17,41.19-29.89,77-27,31.88,2.57,60.23,28.82,64,34,8,11,14.18,38,4,47-4-8-18.55-16-29-16-37,0-61-13-61-13s7,22-15,38c0,16-3,14-5,21s1,16-12,18c-6-13-20-29.39-35-15C984.5,603.5,999.5,636.94,1025.5,625.5Z"
				transform="translate(-878.5 -427.5)"
			/>
		</g>
	</svg>
);
export default CheveuxF3;
